<template>
  <div class="page flex-col">
    <div class="section_1 flex-col">
      <div class="box_1 flex-col">
        <div style="margin-left: -120px;">
<!--          <div class="section_19 flex-row justify-between">-->
<!--            <img class="image_10" referrerpolicy="no-referrer"-->
<!--                 src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />-->
<!--            <div class="image-text_6 flex-row justify-between">-->
<!--              <span class="text-group_7">企业荣誉</span>-->
<!--              <img class="image_11" referrerpolicy="no-referrer"-->
<!--                   src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />-->
<!--            </div>-->
<!--          </div>-->
          <div class="box_24 flex-row justify-between" style="margin-top: 0">
            <img class="image_1" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <div class="image-text_4 flex-row justify-between">
              <span class="text-group_7">战略布局</span>
              <img class="image_2" referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
            </div>
          </div>
          <div class="box_25 flex-row">
            <div class="text-wrapper_27 flex-col">
              <span class="text_1">[&nbsp;长三角区域业务运营中心&nbsp;]</span>
              <span class="text_2">[&nbsp;2024年&nbsp;&nbsp;明晟落户中新苏滁高新区&nbsp;]</span>
              <span class="text_3">[&nbsp;数据标注与处理中心&nbsp;]</span>
              <span class="text_4">[&nbsp;大湾区区域业务运营中心&nbsp;]</span>
              <span class="text_5">[&nbsp;海外业务运营中心&nbsp;]</span>
            </div>
            <div class="group_1 flex-col">
              <div class="section_10 flex-row">
                <div class="section_2 flex-col"></div>
                <div class="section_3 flex-col"></div>
                <div class="section_4 flex-col"></div>
                <div class="section_5 flex-col"></div>
              </div>
              <div class="section_11 flex-row justify-between">
                <div class="group_15 flex-col justify-between">
<!--                  <img class="image_3" referrerpolicy="no-referrer"-->
<!--                    src="./assets/img/MasterDDSSlicePNG78bc1e2eb88227bf5d3d5688b32d402c.png" />-->
                  <div class="group_4 flex-col"></div>
                </div>
                <div class="group_16 flex-col justify-between">
                  <span class="text_6">江苏泗阳</span>
                  <div class="box_6 flex-col"></div>
                  <span class="text_7">安徽滁州总部</span>
                </div>
              </div>
              <div class="section_12 flex-row justify-between">
                <div class="section_6 flex-col"></div>
                <span class="text_8">重庆云阳</span>
              </div>
              <div class="section_13 flex-row justify-between">
                <div class="box_7 flex-col"></div>
                <span class="text_9">澳门</span>
              </div>
              <div class="section_14 flex-row justify-between">
                <div class="group_8 flex-col"></div>
                <span class="text_10">新加坡</span>
              </div>
              <div class="group_9 flex-col"></div>
              <img class="image_4" referrerpolicy="no-referrer"
                src="./assets/img/logo.png" />
            </div>
          </div>
        </div>
        <FooterVue></FooterVue>
      </div>
      <div class="box_26 flex-col" style="margin-top: 60px">
        <HeadVue></HeadVue>
        <img class="image_6" referrerpolicy="no-referrer"
          src="./assets/img/MasterDDSSlicePNG410714fd0ca301e8ba8ddc231e68e570.png" />
          <div class="section_17 flex-row justify-between">
            <div class="text-group_9 flex-col justify-between">
              <span class="text_37">专注于垂直领域大语言模型技术创新的领军企业</span>
              <span class="text_38">
                明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域。
              </span>
              <span class="text_39">
                公司依托自主研发的明晟大语言模型，提供全方位、定制化的技术服务，包括训练数据标准化处理、模型私有化定制及一体化解决方案开发。从算力支撑到应用软件、硬件集成，明晟智能全方位赋能客户，精准满足其个性化需求。
              </span>
            </div>
            <img class="image_7" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNGdb35e2bd8a287e8427d925278e7880f7.png" />
          </div>
          <div class="list_4 flex-row">
            <div class="text-group_4 flex-col" :style="{ background: item.lanhuBg0 }" v-for="(item, index) in loopData1"
              :key="index">
              <span class="text_40" v-html="item.lanhutext0"></span>
              <span class="text_41" v-html="item.lanhutext1"></span>
            </div>
          </div>
          <div class="section_18 flex-row justify-between">
            <img class="image_8" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <div class="image-text_5 flex-row justify-between">
              <span class="text-group_5">明晟大事记</span>
              <img class="image_9" referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
            </div>
          </div>
          <div class="box_22 flex-col">
            <div class="text-wrapper_36 flex-row">
              <span class="text_42">2021</span>
              <span class="text_43">2022</span>
              <span class="text_44">2023</span>
              <span class="text_45">2024</span>
            </div>
            <div class="box_27 flex-row">
              <div class="group_10 flex-col"></div>
            </div>
            <div class="box_28 flex-row justify-between">
              <div class="group_11 flex-col">
                <div class="text-wrapper_12">
                  <ul>
                    <li v-for="(item, index) in year2021Events" :key="index" class="text_46">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="group_12 flex-row">
                <div class="text-group_10 flex-col justify-between">
                  <div class="text-wrapper_16">
                    <ul>
                      <li v-for="(item, index) in year2022Events" :key="index" class="text_54">
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="group_13 flex-col">
                <div class="text-wrapper_19">
                  <ul>
                    <li v-for="(item, index) in year2023Events" :key="index" class="text_60">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="group_14 flex-col">
                <div class="text-wrapper_23">
                  <ul>
                    <li v-for="(item, index) in year2024Events" :key="index" class="text_68">
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="block_7 flex-col"></div>
            <div class="block_8 flex-col"></div>
            <div class="block_9 flex-col"></div>
            <div class="block_10 flex-col"></div>
          </div>
          <div class="section_19 flex-row justify-between">
            <img class="image_10" referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png" />
            <div class="image-text_6 flex-row justify-between">
              <span class="text-group_7">企业荣誉</span>
              <img class="image_11" referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png" />
            </div>
          </div>
          <span class="text_76">科技创新成果丰硕</span>
          <span class="paragraph_1">
            已申请专利100+项，其中发明专利占比60%以上
            <br />
            拥有计算机软件著作权80+项
            <br />
            <br />
            已建设1个省级科技创新平台主持5项人工智能产业团体标准制定工作
          </span>
          <img class="image_12" referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNGf0bf247bec2ba935975e8184c6f534c8.png" />
      </div>
    </div>
  </div>
</template>
<script>
import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    HeadVue,
    FooterVue
  },
  data() {
    return {
      loopData0: [
        { lanhutext0: '公司简介', lanhutext1: '团队介绍' },
        { lanhutext0: '今日头条', lanhutext1: '西瓜视频' }
      ],
      loopData1: [
        {
          lanhuBg0:
            `url(${require('./assets/img/shiming.png')}) 100% no-repeat`,
          lanhutext0: '使命',
          lanhutext1: '用智能科技改变世界，让AI触手可及'
        },
        {
          lanhuBg0:
            `url(${require('./assets/img/yuanjing.png')}) 100% no-repeat`,
          lanhutext0: '愿景',
          lanhutext1: '成为全球领先的智能科技解决方案提供商'
        },
        {
          lanhuBg0:
            `url(${require('./assets/img/liaoyuan.png')}) 100% no-repeat`,
          lanhutext0: '燎原精神',
          lanhutext1: '以星火燎原之势，不畏艰难，勇于创新，团结协作，将每一份努力汇聚成推动行业变革的强大力量'
        }
      ],
      year2021Events: [
        '恒智日晟在武汉学院腾讯众创空间515办公室创立',
        '区块链农产溯源平台上线',
        '区块链数据确权平台上线',
        '大数据舆情分析平台上线'
      ],
      year2022Events: [
        '湖北省明呈创新科技研发中心成立',
        '自然语言处理算法研究',
        '研发基于堆叠BI-LSTM网络和协同注意力算法'
      ],
      year2023Events: [
        '重庆云阳数据处理与标注中心成立',
        '获批国家高新技术企业、国家创新型中小科技型企业',
        '荣获「湖北省首批数字经济应用场景」',
        '明晟大模型21B上线'
      ],
      year2024Events: [
        '明晟智能总部落户中新苏滁高新区',
        '苏滁明晟人工智能众创空间成立',
        '湖北大学人工智能学院硕士生联培基地成立',
        '武汉学院产学研合作基地成立'
      ],
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
